import { render, staticRenderFns } from "./bc.vue?vue&type=template&id=0f7a6fec&scoped=true"
import script from "./bc.vue?vue&type=script&lang=js"
export * from "./bc.vue?vue&type=script&lang=js"
import style0 from "./bc.vue?vue&type=style&index=0&id=0f7a6fec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7a6fec",
  null
  
)

export default component.exports